import {
  createToastEntry,
  getToastIcon,
  normalizeToastArgs,
  scheduleToastDismiss,
} from "@/utils/toast";

/**
 * Local `toasts` array + `ToastContainer` — same API as team dashboards.
 * Usage: `mixins: [toastMixin]`, template: `<ToastContainer :toasts="toasts" @remove="removeToast" />`
 */
export default {
  data() {
    return {
      toasts: [],
    };
  },

  methods: {
    /**
     * @param {string} a - type or title
     * @param {string} [b] - title or message
     * @param {string} [c] - message or type
     */
    showToast(a, b, c) {
      const { type, title, message } = normalizeToastArgs(a, b, c);
      const toast = createToastEntry({ type, title, message });
      this.toasts.push(toast);

      const timer = scheduleToastDismiss(toast, (id) => this.removeToast(id));
      toast._timer = timer;
    },

    removeToast(id) {
      const index = this.toasts.findIndex((t) => t.id === id);
      if (index === -1) return;
      const toast = this.toasts[index];
      if (toast._timer) {
        clearInterval(toast._timer);
      }
      this.toasts.splice(index, 1);
    },

    getToastIcon,
  },
};
